import styled from 'styled-components'

import Icon from 'components/icons'
import mediaQueries from 'components/media-queries'
import { common as commonE2eClasses } from 'constants/e2eClasses'

export const WrapperCheckbox = styled.div`
  display: flex;
  align-items: center;
`

export const CheckboxContainer = styled.div.attrs(props => ({
  className: `${commonE2eClasses.checkbox}${props.e2eClass || props.name || ''}`
}))`
  display: flex;
  position: relative;
  align-items: center;
  width: ${({ width }) => (width ? width : '100%')};
  label {
    color: ${({ theme, disabled }) => disabled && theme.colors.accessibleGrey};
  }
  cursor: ${({ disabled }) => (disabled ? 'no-drop' : 'pointer')};
  padding: ${({ padding }) => (padding ? padding : '5px 0px')};
  ${({ spaceBetween }) =>
    spaceBetween &&
    `
    justify-content: space-between;
  `};
  ${({ invert }) =>
    invert &&
    `
    flex-direction: row-reverse;
  `};
  -webkit-tap-highlight-color: transparent;
`

export const StyledCheckbox = styled.input.attrs(props => ({
  className: `${commonE2eClasses.checkboxInput}${props.e2eClass || ''}`,
  type: 'checkbox'
}))`
  /* removing default appearance */
  -webkit-appearance: none;
  appearance: none;

  ${({ small }) =>
    small
      ? `
    width: 14px;
    min-width: 14px;
    height: 14px;
  `
      : `
    width: 16px;
    min-width: 16px;
    height: 16px;
  `};
  background-color: ${({ theme, checked }) => (checked ? theme.colors.blue : theme.colors.white)};
  border: solid 1px ${({ theme }) => theme.colors.blue};
  border-radius: 1px;

  ${props =>
    props.disabled &&
    `
    background-color: ${({ theme }) => theme.colors.grayLighter};
    border-color: ${({ theme }) => theme.colors.grayLight};
  `};

  ${props =>
    props.rounded &&
    `
    border-radius: 50%;
    width: 20px;
    min-width: 20px;
    height: 20px;
  `};

  ${props =>
    props.checkAlignTop &&
    `
    align-self: baseline;
    margin-top: 3px;
  `};
`

export const CheckedIcon = styled(Icon)`
  ${({ checked }) => (checked ? 'display: block' : 'display: none')};
  position: absolute;
  ${props =>
    !props.rounded &&
    `
    padding: 0 1px 2px 0;
  `};
`

export const CheckboxChildren = styled.label.attrs(props => ({
  className: `${commonE2eClasses.checkboxTitle}${props.e2eClass || ''}`
}))`
  padding-left: 10px;
  font-size: ${({ large }) => (large ? '16px' : '14px')};
  font-family: ${({ theme }) => theme.fonts.regular};
  color: ${({ theme }) => theme.colors.doveGray};
  ${props =>
    props.disabled &&
    `
    color: ${({ theme }) => theme.colors.grayLight};
  `};

  ${props =>
    props.checked &&
    props.disabled &&
    `
    color: ${({ theme }) => theme.colors.grayLight};
  `};

  ${mediaQueries.tablet`
    height: auto;
  `};
`
